export default __webpack_public_path__ + "dea5768cb3bb7f29d33914ee47ae9016.png";